import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import FormGenerator from './FormGenerator'

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/:slug" children={<FormGenerator />} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
